export default "__VITE_ASSET__BkKA83RD__"